import React from "react";
import { ShieldCheck, BadgeCheck, Briefcase, Phone } from "lucide-react";

export function TrustBadges({ verification = {}, size = "sm", showLevel = false, level }) {
  const items = [
    { on: verification.phone_verified, icon: Phone, label: "Phone" },
    { on: verification.identity_verified, icon: BadgeCheck, label: "ID" },
    { on: verification.professional_verified, icon: Briefcase, label: "Pro" },
  ];
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {items.filter((i) => i.on).map((i) => (
        <span key={i.label} className={`inline-flex items-center gap-1 rounded-full bg-mint/10 font-semibold text-mint ${pad}`}>
          <i.icon className="h-3 w-3" strokeWidth={2.5} /> {i.label}
        </span>
      ))}
      {showLevel && level && <TrustLevel level={level} />}
    </div>
  );
}

export function TrustLevel({ level }) {
  const map = {
    HIGH: "bg-mint/10 text-mint",
    MODERATE: "bg-sunset/10 text-sunset",
    LOW: "bg-gray-100 text-gray-500",
  };
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${map[level] || map.LOW}`}>
      <ShieldCheck className="h-3 w-3" strokeWidth={2.5} /> {level} trust
    </span>
  );
}
